import React, { useState, useRef } from 'react';
import { InputTextarea } from 'primereact/inputtextarea';
import { Panel } from 'primereact/panel';
import dayjs from 'dayjs';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import _ from 'lodash';

const CounselingView = () => {
  const data = JSON.parse(sessionStorage.getItem('data'));
  const [allText, setAllText] = useState(data);
  const [loading, setLoading] = useState(false);
  const reportRef = useRef(null);

  // console.log(data);
  const buildWatermark = (now) => {
    const watermark = document.createElement('div');
    _.map(
      _.split(
        'cerp-watermark absolute top-50 left-0 right-0 opacity-40 text-gray-500 font-bold p-4rem text-center text-4xl origin-center',
        ' '
      ),
      (cls) => watermark.classList.add(cls)
    );
    watermark.style.transform = 'rotate(-30deg)';
    const text = document.createTextNode(`출력일시 : ${now}`);
    watermark.appendChild(text);

    return watermark;
  };

  const handlePDF = async () => {
    setLoading(true);

    const papers = reportRef.current.querySelectorAll('.paper');
    if (papers.length === 0) return false;

    const now = dayjs().format('YYYY-MM-DD HH:mm:ss');
    const pageImages = [];
    const reportPDF = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: 'a4',
      compress: true,
    });

    for (let i = 0; i < papers.length; i++) {
      const page = papers[i];
      const watermark = buildWatermark(now);
      page.appendChild(watermark);

      const canvas = await html2canvas(page, {
        scale: 2,
        logging: true,
        allowTaint: false,
        useCORS: true,
        imageTimeout: 0,
        backgroundColor: 'transparent',
      });

      const pageImage = canvas.toDataURL('image/png');
      pageImages.push(pageImage);
      page.removeChild(watermark);
    }

    for (let i = 0; i < pageImages.length; i++) {
      reportPDF.addImage(
        pageImages[i],
        'PNG',
        0,
        0,
        210,
        297,
        `PAGE-${i}`,
        'NONE',
        0
      );
      if (i < pageImages.length - 1) reportPDF.addPage();
    }

    reportPDF.save(`상담이력.pdf`);
    setLoading(false);
  };

  return (
    <div className="p-2" ref={reportRef}>
      <Panel header="전체 상담 이력">
        <InputTextarea
          value={allText}
          onChange={(e) => {
            setAllText(e.target.value);
          }}
          rows={50}
          className="w-full ml-1 text-lg"
        />

        <div
          onClick={() => {
            handlePDF();
          }}
        >
          다운로드
        </div>
      </Panel>
    </div>
  );
};

export default CounselingView;
